import {
  useMutationReadNotifications,
  useQueryInfiniteAllNotificationAlert,
  useQueryNotificationAlertCountUnread,
} from '@/api/queries/notification';
import NotificationItem from './components/NotificationItem';
import ChecksIcon from '@/assets/icons/checks.svg';
import { Anchor } from 'lucide-react';
import { Fragment } from 'react';
import { NotificationItemSkeleton } from './components/NotificationItemSkeleton';
import toast from 'react-hot-toast';
import clsx from 'clsx';

type Props = {};

export default function NotificationPort({}: Props) {
  const dataNotificationPort = useQueryInfiniteAllNotificationAlert('ports', 'received_at', 'desc');

  const notificationAlertCountUnread = useQueryNotificationAlertCountUnread();

  const { isPending: isPendingReadNotification, mutateAsync: readNotification } =
    useMutationReadNotifications();

  if (
    dataNotificationPort.isLoading ||
    dataNotificationPort?.isFetchingNextPage ||
    isPendingReadNotification
  )
    return <NotificationItemSkeleton />;

  // @ts-ignore
  if ((dataNotificationPort?.data?.pages?.[0]?.data || []).length === 0)
    return (
      <h2 className="focus:outline-none text-sm leading-normal text-center pt-8 pb-2 border-gray-300 text-gray-600 notification-center">
        Notification Empty
      </h2>
    );

  return (
    <div className="max-2xl:w-full h-auto overflow-y-auto py-2 px-4 absolute right-0">
      {(notificationAlertCountUnread?.data?.notification_port ?? 0) !== 0 && (
        <button
          disabled={(notificationAlertCountUnread?.data?.notification_port ?? 0) === 0}
          onClick={() => {
            readNotification('ports');
            toast.success('All port notifications marked as read');
          }}
          className={clsx(
            'text-slate-500 hover:text-green-500 mb-2 flex items-center justify-center gap-2 float-right'
          )}
        >
          Mark All as Read <ChecksIcon className="h-4 w-4 ml-2" />
        </button>
      )}

      {!dataNotificationPort?.isLoading && (
        <>
          {dataNotificationPort?.data?.pages.map((group: any, i: any) => (
            <Fragment key={i}>
              {group.data.map((item: any) => (
                <NotificationItem
                  key={item?.id}
                  message={
                    item?.alert_type === 'entry'
                      ? `<p class='text-blue-400'>${item.message}</p>`
                      : item?.alert_type === 'exit'
                      ? `<p class='text-red-400'>${item.message}</p>`
                      : `<p class='text-amber-400'>${item.message}</p>`
                  }
                  Icon={<Anchor className="w-3 h-3" />}
                  date={item.received_at || item.created_at}
                  isRead={
                    !!item.open_at ||
                    (notificationAlertCountUnread?.data?.notification_port ?? 0) === 0
                  }
                />
              ))}
            </Fragment>
          ))}

          {dataNotificationPort.hasNextPage && (
            <div className="flex justify-center items-center">
              <button
                className="focus:outline-none bg-gray-100 text-slate-600 p-3 py-1 rounded-lg text-xs mt-4"
                onClick={() => dataNotificationPort.fetchNextPage()}
              >
                Load More
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
